var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 139,
    viewBox: "0 0 178 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0703 124.249C75.7233 123.178 79.2066 132.479 82.0344 133.324C72.6476 132.512 68.1177 128.042 67.0703 124.249Z",
    fill: "url(#paint0_linear_198_56478)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1797 122.004C65.3265 121.754 68.3194 131.453 70.9904 132.519C61.4005 130.994 57.768 125.573 57.1797 122.004Z",
    fill: "url(#paint1_linear_198_56478)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8359 118.482C55.8297 119.837 57.6326 129.272 60.0686 130.555C51.915 128.588 47.933 123.047 47.8359 118.482Z",
    fill: "url(#paint2_linear_198_56478)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3612 113.571C46.6107 116.044 47.3572 125.605 49.5065 127.258C41.4059 124.041 38.7684 117.917 39.3612 113.571Z",
    fill: "url(#paint3_linear_198_56478)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9617 107.308C37.7211 110.554 38.611 121.535 39.5755 122.412C34.0572 119.729 30.1342 113.34 31.9617 107.308Z",
    fill: "url(#paint4_linear_198_56478)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8579 99.7676C31.4845 104.457 29.2404 113.76 30.6648 115.922C24.0901 111.294 23.9729 103.77 25.8579 99.7676Z",
    fill: "url(#paint5_linear_198_56478)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1693 91.2031C25.8329 97.0357 22.1525 105.671 23.1558 107.938C18.3034 102.696 18.1235 95.8868 21.1693 91.2031Z",
    fill: "url(#paint6_linear_198_56478)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8608 81.8926C21.4964 89.2899 16.5738 96.4992 17.2397 98.7641C13.6817 93.519 13.5421 86.9279 17.8608 81.8926Z",
    fill: "url(#paint7_linear_198_56478)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9021 72.127C18.4925 79.6251 12.7652 86.5446 12.9638 88.773C9.77984 82.7552 11.5349 76.3829 15.9021 72.127Z",
    fill: "url(#paint8_linear_198_56478)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 62.1816C16.7397 68.0337 10.3099 77.6355 10.2755 78.2686C8.3592 73.013 9.02586 67.585 15.3042 62.1816Z",
    fill: "url(#paint9_linear_198_56478)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0475 52.3252C16.3304 60.1062 9.38472 65.4589 9.00101 67.5312C7.64382 62.2167 9.00327 57.0335 16.0475 52.3252Z",
    fill: "url(#paint10_linear_198_56478)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1682 42.6855C17.5896 49.903 9.79063 54.9181 9.1964 56.7755C8.00419 48.9862 13.1896 45.7276 18.1682 42.6855Z",
    fill: "url(#paint11_linear_198_56478)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 137.24C70.4871 141.474 76.3555 135.525 81.4871 134.22C70.7461 131.123 67.4972 136.834 59.375 137.24Z",
    fill: "url(#paint12_linear_198_56478)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4688 134.115C59.4554 139.703 65.7456 134.152 70.551 133.409C60.2862 129.466 56.4693 134.565 48.4688 134.115Z",
    fill: "url(#paint13_linear_198_56478)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9766 129.411C47.6687 136.601 55.1258 131.668 59.7341 131.451C49.2461 126.219 45.7151 131.106 37.9766 129.411Z",
    fill: "url(#paint14_linear_198_56478)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2734 123.048C36.7876 131.645 45.3659 127.745 49.2165 128.194C40.4881 121.979 34.5644 125.555 28.2734 123.048Z",
    fill: "url(#paint15_linear_198_56478)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8242 115.075C25.8211 124.237 35.7036 122.567 39.3399 123.364C29.541 115.004 26.3011 118.916 19.8242 115.075Z",
    fill: "url(#paint16_linear_198_56478)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8984 105.8C17.6381 116.259 27.0272 115.55 30.409 116.95C22.2987 107.212 18.5758 110.363 12.8984 105.8Z",
    fill: "url(#paint17_linear_198_56478)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 95.6357C10.7902 106.537 21.0415 107.748 22.8235 109.072C18.2488 99.5662 12.0623 100.14 7.64062 95.6357Z",
    fill: "url(#paint18_linear_198_56478)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99609 84.9229C5.31297 95.8132 15.0873 98.2125 16.7916 100.002C13.6382 89.7693 7.55255 89.5849 3.99609 84.9229Z",
    fill: "url(#paint19_linear_198_56478)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83307 73.9111C1.3538 83.925 11.3647 88.6087 12.3561 90.1085C11.1146 80.4634 3.97709 77.5295 1.83307 73.9111Z",
    fill: "url(#paint20_linear_198_56478)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08345 62.7568C-0.183406 72.7804 8.46439 77.8307 9.48265 79.7157C8.97875 69.2031 3.83813 67.7436 1.08345 62.7568Z",
    fill: "url(#paint21_linear_198_56478)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77433 51.5654C-0.757148 61.1546 7.41059 67.4657 8.01154 69.0603C8.99397 59.6682 3.97061 56.1551 1.77433 51.5654Z",
    fill: "url(#paint22_linear_198_56478)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96427 40.5947C0.0853157 48.7349 7.75961 57.187 7.96714 58.3434C10.256 49.7531 5.62604 44.8066 3.96427 40.5947Z",
    fill: "url(#paint23_linear_198_56478)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2517 7.87109C26.1246 15.2012 18.8041 26.8665 14.8281 39.7776L15.3836 39.9464C19.3013 27.2196 26.5434 15.6021 33.6735 8.26974L33.2517 7.87109Z",
    fill: "url(#paint24_linear_198_56478)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8787 6.75879C20.2518 16.2247 12.8104 29.7906 9.45703 44.5748L10.0237 44.7002C13.3532 30.0176 20.7475 16.5405 29.3124 7.14399L28.8787 6.75879Z",
    fill: "url(#paint25_linear_198_56478)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8806 0.24707C21.8562 7.43239 12.2454 21.7568 7.34375 37.6391L7.89991 37.8071C12.6896 22.2815 22.1809 7.91616 30.2696 0.677836L29.8806 0.24707Z",
    fill: "url(#paint26_linear_198_56478)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.925 124.247C102.272 123.176 98.7888 132.477 95.9609 133.322C105.348 132.51 109.878 128.04 110.925 124.247Z",
    fill: "url(#paint27_linear_198_56478)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M120.834 122.002C112.687 121.752 109.695 131.451 107.023 132.517C116.613 130.992 120.246 125.571 120.834 122.002Z",
    fill: "url(#paint28_linear_198_56478)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M130.17 118.48C122.176 119.835 120.373 129.27 117.938 130.553C126.091 128.586 130.073 123.045 130.17 118.48Z",
    fill: "url(#paint29_linear_198_56478)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138.642 113.569C131.392 116.042 130.646 125.603 128.496 127.256C136.597 124.039 139.235 117.915 138.642 113.569Z",
    fill: "url(#paint30_linear_198_56478)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146.051 107.306C140.292 110.552 139.402 121.533 138.438 122.41C143.956 119.727 147.879 113.338 146.051 107.306Z",
    fill: "url(#paint31_linear_198_56478)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.155 99.7656C146.528 104.455 148.772 113.758 147.348 115.92C153.922 111.292 154.04 103.768 152.155 99.7656Z",
    fill: "url(#paint32_linear_198_56478)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M156.825 91.2012C152.161 97.0338 155.841 105.669 154.838 107.936C159.691 102.694 159.871 95.8849 156.825 91.2012Z",
    fill: "url(#paint33_linear_198_56478)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M160.129 81.8906C156.494 89.288 161.416 96.4972 160.75 98.7622C164.308 93.5171 164.447 86.926 160.129 81.8906Z",
    fill: "url(#paint34_linear_198_56478)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M162.104 72.125C159.513 79.6231 165.241 86.5427 165.042 88.771C168.226 82.7533 166.471 76.3809 162.104 72.125Z",
    fill: "url(#paint35_linear_198_56478)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162.709 62.1797C161.273 68.0317 167.703 77.6335 167.738 78.2666C169.654 73.0111 168.987 67.583 162.709 62.1797Z",
    fill: "url(#paint36_linear_198_56478)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M161.962 52.3242C161.679 60.1053 168.624 65.4579 169.008 67.5302C170.364 62.2157 169.006 57.0326 161.962 52.3242Z",
    fill: "url(#paint37_linear_198_56478)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M159.844 42.6836C160.422 49.901 168.221 54.9162 168.816 56.7735C170.008 48.9843 164.822 45.7257 159.844 42.6836Z",
    fill: "url(#paint38_linear_198_56478)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M118.629 137.241C107.516 141.475 101.648 135.526 96.5156 134.221C107.257 131.124 110.506 136.835 118.629 137.241Z",
    fill: "url(#paint39_linear_198_56478)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M129.528 134.115C118.541 139.703 112.251 134.152 107.445 133.409C117.71 129.466 121.527 134.565 129.528 134.115Z",
    fill: "url(#paint40_linear_198_56478)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.023 129.411C130.331 136.601 122.874 131.668 118.266 131.451C128.754 126.219 132.285 131.106 140.023 129.411Z",
    fill: "url(#paint41_linear_198_56478)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M149.72 123.048C141.206 131.645 132.628 127.745 128.777 128.194C137.506 121.979 143.429 125.555 149.72 123.048Z",
    fill: "url(#paint42_linear_198_56478)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M158.192 115.078C152.195 124.24 142.312 122.57 138.676 123.367C148.475 115.006 151.715 118.919 158.192 115.078Z",
    fill: "url(#paint43_linear_198_56478)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M165.112 105.8C160.372 116.259 150.983 115.55 147.602 116.95C155.712 107.212 159.435 110.363 165.112 105.8Z",
    fill: "url(#paint44_linear_198_56478)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M170.37 95.6357C167.221 106.537 156.969 107.748 155.188 109.072C159.762 99.5662 165.949 100.14 170.37 95.6357Z",
    fill: "url(#paint45_linear_198_56478)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.999 84.9229C172.682 95.8132 162.907 98.2125 161.203 100.002C164.356 89.7693 170.442 89.5849 173.999 84.9229Z",
    fill: "url(#paint46_linear_198_56478)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M176.179 73.9111C176.659 83.925 166.648 88.6087 165.656 90.1085C166.898 80.4634 174.036 77.5295 176.179 73.9111Z",
    fill: "url(#paint47_linear_198_56478)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M176.915 62.7568C178.182 72.7804 169.534 77.8307 168.516 79.7157C169.02 69.2031 174.16 67.7436 176.915 62.7568Z",
    fill: "url(#paint48_linear_198_56478)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M176.222 51.5654C178.754 61.1546 170.586 67.4657 169.985 69.0603C169.003 59.6682 174.026 56.1551 176.222 51.5654Z",
    fill: "url(#paint49_linear_198_56478)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M174.021 40.5947C177.9 48.7349 170.226 57.187 170.018 58.3434C167.729 49.7531 172.359 44.8066 174.021 40.5947Z",
    fill: "url(#paint50_linear_198_56478)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M144.758 7.87012C151.885 15.2003 159.205 26.8655 163.181 39.7767L162.626 39.9454C158.708 27.2186 151.466 15.6011 144.336 8.26876L144.758 7.87012Z",
    fill: "url(#paint51_linear_198_56478)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M149.133 6.75781C157.76 16.2238 165.201 29.7897 168.555 44.5739L167.988 44.6993C164.658 30.0166 157.264 16.5395 148.699 7.14301L149.133 6.75781Z",
    fill: "url(#paint52_linear_198_56478)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M148.131 0.246094C156.156 7.43141 165.766 21.7558 170.668 37.6381L170.112 37.8061C165.321 22.2806 155.831 7.91518 147.742 0.676859L148.131 0.246094Z",
    fill: "url(#paint53_linear_198_56478)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5029 133.766C92.5029 135.85 90.8135 137.539 88.7299 137.539C86.6464 137.539 84.957 135.85 84.957 133.766C84.957 131.683 86.6464 129.993 88.7299 129.993C90.8135 129.993 92.5029 131.683 92.5029 133.766Z",
    fill: "url(#paint54_linear_198_56478)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5589 92.1973C59.6291 92.2152 59.6761 92.2458 59.7023 92.2883C59.7284 92.3316 59.7366 92.3794 59.7284 92.4317C59.7194 92.4839 59.6933 92.5302 59.65 92.5691C59.6067 92.6079 59.5455 92.6273 59.4671 92.6273H51.2777C51.2172 92.6273 51.1672 92.6101 51.1277 92.575C51.0881 92.5407 51.0627 92.4996 51.0493 92.4511C51.0366 92.4033 51.0448 92.3585 51.0754 92.3145C51.106 92.2704 51.1642 92.2368 51.2516 92.21C51.3389 92.1846 51.4927 92.1368 51.7144 92.0666C51.9362 91.9972 52.1496 91.8822 52.3534 91.721C52.558 91.5605 52.7162 91.3448 52.8297 91.076C52.9424 90.8058 52.9297 90.4631 52.7909 90.0458C52.7476 89.9323 52.6886 89.7636 52.6147 89.5374C52.5408 89.3112 52.4602 89.0619 52.3736 88.7879C52.2863 88.5139 52.1929 88.2317 52.0929 87.9406C51.9929 87.6487 51.9033 87.3799 51.8249 87.1321C51.7473 86.8842 51.6771 86.6737 51.6166 86.4998C51.5554 86.3266 51.5211 86.2213 51.5121 86.187C51.486 86.1086 51.4382 86.0698 51.3688 86.0698H45.7482C45.6698 86.0698 45.6175 86.1041 45.5914 86.1743C45.5563 86.2788 45.5026 86.4528 45.4286 86.6961C45.3547 86.9395 45.2697 87.2135 45.1741 87.5173C45.0786 87.8219 44.9808 88.1406 44.8807 88.4758C44.7807 88.8103 44.6874 89.1208 44.6 89.4083C44.5127 89.6949 44.4373 89.945 44.3716 90.1577C44.3067 90.3705 44.2693 90.5079 44.2611 90.5691C44.1909 90.8901 44.2066 91.1521 44.3066 91.3514C44.4067 91.5515 44.5433 91.7098 44.7173 91.827C44.8912 91.9442 45.0778 92.0293 45.2779 92.0816C45.4779 92.1338 45.6429 92.1779 45.7736 92.2115C45.852 92.2294 45.9042 92.2615 45.9304 92.3093C45.9565 92.3578 45.9647 92.4056 45.9565 92.4526C45.9475 92.5011 45.9214 92.5421 45.8788 92.5765C45.8348 92.6116 45.7825 92.6287 45.722 92.6287H40.8965C40.8271 92.6287 40.7726 92.6116 40.7338 92.5765C40.695 92.5421 40.6733 92.5033 40.6688 92.4593C40.6643 92.4153 40.6778 92.3704 40.7084 92.3219C40.739 92.2741 40.789 92.2413 40.8584 92.2241C41.0846 92.1637 41.3064 92.089 41.5236 92.0024C41.7408 91.9151 41.9431 91.8046 42.1305 91.6695C42.3171 91.5351 42.4866 91.3723 42.6389 91.1805C42.7904 90.9894 42.9196 90.764 43.0233 90.5027C43.0756 90.3728 43.1884 90.0622 43.3623 89.5702C43.5362 89.079 43.749 88.4751 44.0013 87.7584C44.2536 87.041 44.5321 86.2475 44.8359 85.3785C45.1405 84.5095 45.4466 83.6294 45.7557 82.738C46.064 81.8467 46.3663 80.9777 46.6619 80.1297C46.9576 79.2824 47.2181 78.5283 47.4443 77.8677C47.6705 77.207 47.8549 76.6725 47.9982 76.2634C48.1415 75.855 48.2177 75.6371 48.2267 75.6117C48.2618 75.5161 48.3043 75.4422 48.3566 75.39C48.4088 75.3377 48.4917 75.3034 48.6044 75.2862C48.7955 75.2511 49.0172 75.2033 49.2695 75.1429C49.5211 75.0817 49.7802 75.0167 50.0452 74.9473C50.3102 74.8778 50.573 74.8017 50.8343 74.7189C51.0948 74.6367 51.3337 74.5479 51.551 74.4516C51.6988 74.3821 51.8055 74.3642 51.8704 74.3993C51.9361 74.4344 51.9899 74.5039 52.0332 74.6076C52.0422 74.6338 52.1138 74.851 52.249 75.2601C52.3833 75.6684 52.5617 76.2014 52.7835 76.8576C53.0052 77.5146 53.2552 78.2641 53.533 79.1077C53.8107 79.9512 54.1003 80.8202 54.4004 81.716C54.6998 82.6111 54.9977 83.5025 55.2933 84.3893C55.5889 85.2762 55.8606 86.0892 56.1085 86.8283C56.3563 87.5673 56.5668 88.2041 56.7408 88.7379C56.914 89.2724 57.0364 89.6359 57.1058 89.827C57.2357 90.2011 57.3903 90.5243 57.5687 90.7983C57.7464 91.0723 57.9427 91.3067 58.1555 91.503C58.3682 91.6986 58.5922 91.8531 58.8274 91.9658C59.064 92.0756 59.3074 92.154 59.5589 92.1973ZM45.958 85.0515C45.9147 85.165 45.949 85.221 46.0625 85.221H51.0306C51.1351 85.221 51.1695 85.1687 51.1351 85.065C51.1262 85.0388 51.0851 84.9104 51.0112 84.6797C50.9373 84.4498 50.8387 84.1542 50.7178 83.7929C50.5954 83.4323 50.461 83.0254 50.3132 82.5738C50.1654 82.1214 50.0131 81.663 49.857 81.1979C49.7003 80.7328 49.5488 80.276 49.4009 79.8288C49.2531 79.3816 49.1202 78.9815 49.003 78.6291C48.8858 78.2775 48.7903 77.9924 48.7164 77.7751C48.6425 77.5579 48.6051 77.4444 48.6051 77.4354C48.588 77.375 48.5507 77.3488 48.4947 77.3578C48.4379 77.366 48.4014 77.3966 48.3842 77.4489C48.3752 77.4661 48.3237 77.6251 48.2274 77.9244C48.1311 78.2245 48.0094 78.6068 47.8623 79.0718C47.7145 79.5369 47.5495 80.0543 47.3666 80.6239C47.1845 81.1935 47.0038 81.7564 46.8254 82.3125C46.647 82.8694 46.482 83.3905 46.3297 83.8772C46.1774 84.3647 46.0535 84.7559 45.958 85.0515Z",
    fill: "#121212"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6018 75.0406C82.6623 75.0406 82.7123 75.0577 82.7519 75.0928C82.7907 75.1279 82.8153 75.169 82.8235 75.2168C82.8317 75.2645 82.8213 75.3101 82.7907 75.3534C82.7601 75.3967 82.7101 75.4273 82.6406 75.4444C82.1793 75.5661 81.7642 75.7527 81.3954 76.0051C81.0259 76.2574 80.728 76.6441 80.5026 77.1652C80.3809 77.4436 80.2181 77.8438 80.0136 78.3649C79.809 78.8859 79.5746 79.4861 79.3096 80.1647C79.0446 80.8426 78.7616 81.5779 78.4623 82.3685C78.1622 83.1598 77.8561 83.966 77.5426 84.7872C77.2298 85.6084 76.9207 86.4236 76.6169 87.2321C76.3123 88.0406 76.0279 88.8013 75.7629 89.5142C75.4979 90.2272 75.256 90.8722 75.0387 91.4507C74.8215 92.0293 74.6475 92.4921 74.5176 92.8393C74.4736 92.9438 74.4072 93.002 74.3153 93.0155C74.2243 93.0289 74.1563 92.9744 74.113 92.8527C74.0436 92.6444 73.9369 92.3399 73.7935 91.9397C73.6502 91.5403 73.4845 91.0789 73.2978 90.5571C73.1112 90.0353 72.9111 89.4769 72.6976 88.8819C72.4849 88.2862 72.2744 87.6927 72.0653 87.1022C71.857 86.5109 71.6525 85.9399 71.4524 85.3874C71.2524 84.8357 71.0762 84.3468 70.9246 83.9205C70.7723 83.4943 70.6462 83.1464 70.5469 82.8769C70.4469 82.6074 70.3923 82.4596 70.3841 82.4334C70.3491 82.364 70.3058 82.3334 70.2535 82.3424C70.2012 82.3513 70.1579 82.3946 70.1236 82.4723C69.8713 83.1247 69.6167 83.7913 69.3607 84.4737C69.1046 85.1567 68.85 85.8324 68.5977 86.5012C68.3454 87.1709 68.0998 87.8249 67.8609 88.4639C67.622 89.1029 67.4003 89.6964 67.1957 90.2443C66.9912 90.7915 66.8046 91.2895 66.6351 91.7374C66.4656 92.1853 66.3283 92.5526 66.2245 92.8393C66.1812 92.9438 66.1133 93.002 66.0222 93.0155C65.9311 93.0289 65.8632 92.9744 65.8199 92.8527C65.7064 92.5317 65.5571 92.1054 65.3705 91.5747C65.1831 91.0439 64.9704 90.4422 64.7315 89.7688C64.4926 89.0947 64.2365 88.3758 63.9625 87.6106C63.6885 86.8462 63.4101 86.0705 63.1279 85.2829C62.8457 84.4961 62.565 83.7227 62.2866 82.962C62.0081 82.2013 61.7453 81.4906 61.4975 80.8299C61.2496 80.1692 61.0234 79.5802 60.8189 79.0629C60.6143 78.5455 60.4426 78.1394 60.3038 77.8438C59.9731 77.1226 59.6058 76.5702 59.2019 76.188C58.7973 75.805 58.3479 75.5661 57.8522 75.4706C57.7828 75.4616 57.735 75.4332 57.7089 75.3854C57.6827 75.3377 57.6745 75.2877 57.6827 75.2354C57.691 75.1831 57.7178 75.1376 57.7604 75.0988C57.8044 75.06 57.8649 75.0406 57.9433 75.0406H74.4266C74.4871 75.0406 74.5371 75.0577 74.5767 75.0928C74.6155 75.1279 74.6416 75.169 74.6543 75.2168C74.6677 75.2645 74.6587 75.3101 74.6281 75.3534C74.5975 75.3967 74.5386 75.4318 74.452 75.4579C74.3915 75.4751 74.3019 75.5012 74.1847 75.5363C74.0675 75.5713 73.9391 75.6206 73.7995 75.6863C73.6607 75.752 73.5218 75.8349 73.3822 75.9342C73.2433 76.0342 73.1277 76.1626 73.0366 76.3186C72.9455 76.4746 72.8842 76.6598 72.8536 76.8725C72.823 77.0853 72.8477 77.3354 72.9253 77.6221C73.0119 77.961 73.1359 78.3678 73.2971 78.8411C73.4576 79.3152 73.6338 79.8213 73.8249 80.3603C74.016 80.9 74.2138 81.4495 74.4184 82.0101C74.6229 82.5708 74.8208 83.1038 75.0119 83.6077C75.203 84.1124 75.3769 84.5685 75.5337 84.9768C75.6897 85.3859 75.8114 85.7069 75.8987 85.9421C75.9338 86.0197 75.9794 86.0571 76.0354 86.0526C76.0921 86.0481 76.1332 86.0115 76.1593 85.9421C76.2459 85.6987 76.3698 85.3554 76.531 84.9119C76.6915 84.4685 76.87 83.9728 77.0656 83.4248C77.2612 82.8769 77.468 82.299 77.6852 81.6899C77.9024 81.0815 78.1115 80.4902 78.3115 79.9169C78.5116 79.3435 78.6915 78.8083 78.8527 78.3126C79.0132 77.8169 79.1416 77.4085 79.2372 77.0868C79.3238 76.7732 79.3193 76.5172 79.2245 76.3171C79.1282 76.1171 78.9916 75.9588 78.8132 75.8416C78.6348 75.7244 78.4422 75.6393 78.2331 75.587C78.0241 75.5348 77.8546 75.4915 77.7247 75.4564C77.6464 75.4392 77.5941 75.4064 77.568 75.3586C77.5426 75.3108 77.5329 75.263 77.5426 75.2153C77.5515 75.1675 77.5747 75.1264 77.6142 75.0913C77.6538 75.0562 77.7076 75.0391 77.777 75.0391H82.6018V75.0406ZM67.8661 85.9429C67.9184 85.795 67.9945 85.586 68.0945 85.3165C68.1946 85.047 68.3051 84.7424 68.4275 84.4035C68.5492 84.0638 68.6753 83.71 68.8052 83.3404C68.9359 82.9709 69.0531 82.6163 69.1576 82.2774C69.2614 81.9385 69.3465 81.6317 69.4122 81.3584C69.4771 81.0845 69.51 80.8695 69.51 80.7127C69.51 80.4775 69.4749 80.2237 69.4055 79.9497C69.336 79.6757 69.2509 79.4062 69.1509 79.1412C69.0509 78.8762 68.9486 78.6306 68.8448 78.4044C68.7403 78.179 68.6574 77.9916 68.597 77.8438C68.4402 77.4959 68.2729 77.1943 68.0945 76.9375C67.9161 76.6814 67.7168 76.4679 67.4951 76.2985C67.2734 76.129 67.0255 76.0051 66.7523 75.9267C66.4783 75.8483 66.167 75.8095 65.8199 75.8095C65.637 75.8095 65.4548 75.8401 65.2719 75.9005C65.0891 75.9618 64.9375 76.0618 64.8158 76.2007C64.6934 76.3403 64.609 76.5269 64.5612 76.7613C64.5135 76.9965 64.5374 77.2831 64.6329 77.6221C64.7195 77.961 64.8419 78.3678 64.998 78.8411C65.154 79.3152 65.3287 79.8213 65.519 80.3603C65.7102 80.9 65.9102 81.4495 66.1192 82.0101C66.3282 82.5708 66.5276 83.1038 66.7194 83.6077C66.9106 84.1124 67.0845 84.5685 67.2413 84.9768C67.3981 85.3859 67.5197 85.7069 67.6063 85.9421C67.6414 86.0197 67.6869 86.0571 67.7437 86.0526C67.7982 86.0496 67.84 86.0123 67.8661 85.9429Z",
    fill: "#121212"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2628 92.1973C99.333 92.2152 99.38 92.2458 99.4061 92.2883C99.4322 92.3316 99.4412 92.3794 99.4322 92.4317C99.424 92.4839 99.3972 92.5302 99.3539 92.5691C99.3106 92.6079 99.2493 92.6273 99.1709 92.6273H90.9816C90.9203 92.6273 90.8711 92.6101 90.8315 92.575C90.7919 92.5407 90.7665 92.4996 90.7531 92.4511C90.7404 92.4033 90.7486 92.3585 90.7792 92.3145C90.8099 92.2704 90.8681 92.2368 90.9554 92.21C91.0428 92.1846 91.1966 92.1368 91.4183 92.0666C91.64 91.9972 91.8535 91.8822 92.0573 91.721C92.2618 91.5605 92.4201 91.3448 92.5336 91.076C92.6463 90.8058 92.6336 90.4631 92.4947 90.0458C92.4514 89.9323 92.3925 89.7636 92.3186 89.5374C92.2447 89.3112 92.1641 89.0619 92.0775 88.7879C91.9901 88.5139 91.8968 88.2317 91.7967 87.9406C91.6967 87.6487 91.6079 87.3799 91.5287 87.1321C91.4511 86.8842 91.3809 86.6737 91.3205 86.4998C91.2592 86.3266 91.2249 86.2213 91.216 86.187C91.1899 86.1086 91.1421 86.0698 91.0726 86.0698H85.452C85.3737 86.0698 85.3214 86.1041 85.2953 86.1743C85.2609 86.2788 85.2064 86.4528 85.1325 86.6961C85.0586 86.9395 84.9735 87.2135 84.8779 87.5173C84.7824 87.8219 84.6846 88.1406 84.5845 88.4758C84.4845 88.8103 84.3912 89.1208 84.3039 89.4083C84.2165 89.6949 84.1411 89.945 84.0755 90.1577C84.0105 90.3705 83.9732 90.5079 83.965 90.5691C83.8955 90.8901 83.9104 91.1521 84.0105 91.3514C84.1105 91.5515 84.2471 91.7098 84.4211 91.827C84.595 91.9442 84.7817 92.0293 84.9817 92.0816C85.1818 92.1338 85.3468 92.1779 85.4774 92.2115C85.5558 92.2294 85.608 92.2615 85.6342 92.3093C85.6595 92.3578 85.6685 92.4056 85.6595 92.4526C85.6513 92.5011 85.6252 92.5421 85.5819 92.5765C85.5379 92.6116 85.4864 92.6287 85.4252 92.6287H80.5996C80.5302 92.6287 80.4757 92.6116 80.4369 92.5765C80.398 92.5421 80.3764 92.5033 80.3719 92.4593C80.3675 92.4153 80.3809 92.3704 80.4115 92.3219C80.4421 92.2741 80.4921 92.2413 80.5615 92.2241C80.7877 92.1637 81.0094 92.089 81.2267 92.0024C81.4439 91.9151 81.6462 91.8046 81.8329 91.6695C82.0195 91.5351 82.189 91.3723 82.3413 91.1805C82.4928 90.9894 82.6219 90.764 82.7257 90.5027C82.778 90.3728 82.8907 90.0622 83.0647 89.5702C83.2386 89.079 83.4513 88.4751 83.7036 87.7584C83.956 87.041 84.2345 86.2475 84.5383 85.3785C84.8429 84.5095 85.1489 83.6294 85.4572 82.738C85.7656 81.8467 86.0679 80.9777 86.3636 80.1297C86.6584 79.2824 86.9197 78.5283 87.1459 77.8677C87.3714 77.207 87.5565 76.6725 87.6998 76.2634C87.8432 75.855 87.9193 75.6371 87.9282 75.6117C87.9633 75.5161 88.0059 75.4422 88.0581 75.39C88.1104 75.3377 88.1933 75.3034 88.306 75.2862C88.4971 75.2511 88.7188 75.2033 88.9712 75.1429C89.2235 75.0817 89.4818 75.0167 89.7468 74.9473C90.0118 74.8778 90.2746 74.8017 90.5359 74.7189C90.7964 74.6367 91.0353 74.5479 91.2525 74.4516C91.4003 74.3821 91.5071 74.3642 91.5721 74.3993C91.6378 74.4344 91.6923 74.5039 91.7356 74.6076C91.7438 74.6338 91.8162 74.851 91.9505 75.2601C92.0849 75.6684 92.2633 76.2014 92.485 76.8576C92.7068 77.5146 92.9569 78.2641 93.2346 79.1077C93.5123 79.9512 93.8019 80.8202 94.102 81.716C94.4014 82.6111 94.6992 83.5025 94.9949 84.3893C95.2905 85.2762 95.5622 86.0892 95.8093 86.8283C96.0572 87.5673 96.2677 88.2041 96.4424 88.7379C96.6156 89.2724 96.738 89.6359 96.8075 89.827C96.9374 90.2011 97.0919 90.5243 97.2703 90.7983C97.448 91.0723 97.6443 91.3067 97.8571 91.503C98.0698 91.6986 98.2938 91.8531 98.5289 91.9658C98.7671 92.0756 99.0105 92.154 99.2628 92.1973ZM85.661 85.0515C85.6177 85.165 85.6528 85.221 85.7656 85.221H90.7345C90.8382 85.221 90.8733 85.1687 90.8382 85.065C90.83 85.0388 90.7882 84.9104 90.7143 84.6797C90.6404 84.4498 90.5419 84.1542 90.4209 83.7929C90.2985 83.4323 90.1641 83.0254 90.0163 82.5738C89.8685 82.1214 89.7162 81.663 89.5602 81.1979C89.4042 80.7328 89.2518 80.276 89.104 79.8288C88.9562 79.3816 88.8234 78.9815 88.7062 78.6291C88.589 78.2775 88.4934 77.9924 88.4195 77.7751C88.3456 77.5579 88.3082 77.4444 88.3082 77.4354C88.2911 77.375 88.2537 77.3488 88.1978 77.3578C88.141 77.366 88.1044 77.3966 88.0873 77.4489C88.0783 77.4661 88.0261 77.6251 87.9305 77.9244C87.835 78.2245 87.7125 78.6068 87.5655 79.0718C87.4176 79.5369 87.2527 80.0543 87.0698 80.6239C86.8869 81.1935 86.7062 81.7564 86.5285 82.3125C86.3501 82.8694 86.1851 83.3905 86.0328 83.8772C85.8813 84.3647 85.7566 84.7559 85.661 85.0515Z",
    fill: "#121212"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M115.735 90.9754C115.84 90.9411 115.938 90.9471 116.029 90.9948C116.12 91.0426 116.144 91.1494 116.1 91.3151C116.048 91.5152 115.938 91.7122 115.768 91.9078C115.599 92.1034 115.385 92.2841 115.129 92.4491C114.872 92.6141 114.579 92.7469 114.249 92.8469C113.919 92.947 113.562 92.997 113.179 92.997C112.858 92.997 112.536 92.9664 112.214 92.906C111.892 92.8447 111.586 92.741 111.294 92.5932C111.003 92.4446 110.74 92.2497 110.506 92.0064C110.271 91.763 110.075 91.4584 109.919 91.0926C109.779 90.7798 109.673 90.4215 109.6 90.0169C109.526 89.613 109.467 89.1501 109.423 88.6283C109.336 87.6205 109.208 86.8225 109.038 86.2357C108.869 85.649 108.673 85.2055 108.451 84.9054C108.23 84.6053 107.992 84.4165 107.741 84.3381C107.488 84.2604 107.245 84.2208 107.01 84.2208C106.714 84.2208 106.51 84.2776 106.397 84.3903C106.284 84.5031 106.228 84.6994 106.228 84.9771V90.2058C106.228 90.6149 106.315 90.9448 106.488 91.1964C106.662 91.4494 106.864 91.6488 107.095 91.7966C107.325 91.9444 107.553 92.0467 107.78 92.1034C108.005 92.1602 108.171 92.1967 108.275 92.2139C108.354 92.2318 108.413 92.2617 108.451 92.305C108.49 92.349 108.508 92.3938 108.504 92.4423C108.499 92.4901 108.475 92.5334 108.432 92.5722C108.388 92.6111 108.323 92.6305 108.236 92.6305H99.9163C99.829 92.6305 99.7641 92.6111 99.7208 92.5722C99.6775 92.5334 99.6536 92.4894 99.6491 92.4423C99.6446 92.3938 99.6626 92.349 99.7014 92.305C99.7402 92.261 99.7991 92.2318 99.8775 92.2139C99.982 92.1967 100.147 92.1602 100.373 92.1034C100.599 92.0474 100.827 91.9452 101.058 91.7966C101.288 91.6488 101.49 91.4494 101.665 91.1964C101.838 90.944 101.925 90.6149 101.925 90.2058V77.4521C101.925 77.052 101.838 76.7235 101.665 76.4674C101.491 76.2113 101.289 76.0113 101.058 75.868C100.827 75.7246 100.599 75.6223 100.373 75.5611C100.147 75.5007 99.982 75.4611 99.8775 75.4439C99.7999 75.4357 99.7409 75.4066 99.7014 75.3596C99.6626 75.3118 99.6446 75.264 99.6491 75.2163C99.6536 75.1685 99.6775 75.1252 99.7208 75.0863C99.7648 75.0468 99.8297 75.0273 99.9163 75.0273H107.949C108.445 75.0273 108.934 75.0318 109.416 75.0408C109.898 75.0497 110.368 75.0931 110.825 75.1707C111.281 75.2483 111.724 75.379 112.155 75.5619C112.585 75.7448 113 76.0098 113.4 76.3569C113.721 76.6443 113.985 76.9855 114.189 77.3812C114.394 77.7768 114.537 78.1919 114.62 78.6264C114.702 79.0609 114.72 79.5043 114.672 79.9567C114.624 80.4083 114.509 80.8301 114.327 81.2213C114.014 81.917 113.605 82.4538 113.101 82.8316C112.596 83.2093 111.992 83.499 111.288 83.6983C111.218 83.7155 111.179 83.7438 111.171 83.7834C111.162 83.8222 111.188 83.8461 111.249 83.855C111.318 83.8722 111.44 83.9028 111.614 83.9461C111.788 83.9902 111.983 84.0618 112.2 84.1619C112.418 84.2619 112.635 84.3993 112.853 84.5724C113.07 84.7464 113.253 84.9636 113.401 85.2249C113.584 85.5467 113.711 85.9528 113.785 86.444C113.859 86.9352 113.905 87.4548 113.922 88.002C113.957 88.6007 113.994 89.0994 114.032 89.495C114.072 89.8907 114.143 90.2013 114.247 90.4275C114.326 90.6104 114.427 90.7462 114.554 90.8381C114.68 90.9291 114.813 90.9926 114.951 91.0277C115.091 91.0628 115.23 91.0732 115.369 91.0605C115.509 91.0471 115.631 91.0187 115.735 90.9754ZM106.528 83.4639C106.755 83.4639 107.005 83.4557 107.279 83.4385C107.553 83.4213 107.827 83.3713 108.1 83.2884C108.374 83.2056 108.639 83.0757 108.896 82.8973C109.152 82.7189 109.378 82.4673 109.573 82.141C109.769 81.8148 109.926 81.4042 110.043 80.9085C110.16 80.4128 110.219 79.8044 110.219 79.0833C110.219 78.4569 110.171 77.9336 110.076 77.5118C109.98 77.09 109.844 76.7511 109.665 76.4943C109.487 76.2382 109.27 76.0531 109.013 75.9404C108.757 75.8276 108.467 75.7709 108.146 75.7709C107.859 75.7709 107.598 75.8082 107.364 75.8814C107.129 75.9553 106.927 76.0747 106.758 76.2397C106.588 76.4047 106.457 76.6137 106.366 76.866C106.275 77.1184 106.229 77.4267 106.229 77.7917V83.1779C106.228 83.3683 106.328 83.4639 106.528 83.4639Z",
    fill: "#121212"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M127.014 75.0273C128.502 75.0273 129.786 75.2535 130.868 75.7059C131.95 76.1583 132.843 76.775 133.547 77.5574C134.252 78.3397 134.773 79.2617 135.112 80.3217C135.451 81.3826 135.62 82.521 135.62 83.7386C135.62 84.9733 135.44 86.1289 135.079 87.2069C134.718 88.2849 134.173 89.2255 133.442 90.0296C132.711 90.8336 131.794 91.4689 130.69 91.934C129.586 92.399 128.291 92.6312 126.804 92.6312H117.702C117.614 92.6312 117.549 92.6118 117.506 92.573C117.462 92.5342 117.439 92.4901 117.434 92.4431C117.43 92.3946 117.448 92.3498 117.487 92.3057C117.525 92.2617 117.584 92.2326 117.663 92.2146C117.767 92.1975 117.932 92.1609 118.158 92.1041C118.384 92.0482 118.612 91.9459 118.843 91.7974C119.073 91.6495 119.275 91.4502 119.449 91.1971C119.623 90.9448 119.71 90.6156 119.71 90.2065V77.4528C119.71 77.0527 119.623 76.7242 119.449 76.4682C119.275 76.2121 119.073 76.012 118.843 75.8687C118.612 75.7254 118.384 75.6231 118.158 75.5619C117.932 75.5014 117.767 75.4618 117.663 75.4447C117.585 75.4365 117.526 75.4074 117.487 75.3603C117.448 75.3126 117.43 75.2648 117.434 75.217C117.439 75.1692 117.463 75.1259 117.506 75.0871C117.55 75.0475 117.615 75.0281 117.702 75.0281H127.014V75.0273ZM126.805 91.8362C127.484 91.8362 128.062 91.6361 128.54 91.236C129.018 90.8366 129.412 90.2819 129.721 89.5735C130.029 88.865 130.253 88.0222 130.392 87.0442C130.531 86.0663 130.601 84.995 130.601 83.8297C130.601 82.6733 130.534 81.6192 130.398 80.6674C130.263 79.7156 130.053 78.8936 129.766 78.2024C129.479 77.5111 129.107 76.9638 128.651 76.5592C128.195 76.1553 127.649 75.9225 127.014 75.862C126.91 75.8538 126.767 75.8471 126.584 75.8426C126.402 75.8381 126.206 75.8336 125.998 75.8291C125.789 75.8247 125.585 75.8232 125.385 75.8232C125.185 75.8232 125.02 75.8232 124.889 75.8232C124.62 75.8232 124.407 75.8971 124.25 76.0449C124.094 76.1927 124.016 76.3883 124.016 76.6317V86.3858C124.016 87.3682 124.061 88.2028 124.153 88.8889C124.244 89.5764 124.399 90.1393 124.616 90.5783C124.833 91.0172 125.121 91.3375 125.477 91.5368C125.832 91.7361 126.275 91.8362 126.805 91.8362Z",
    fill: "#121212"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3267 52.7579C59.2971 53.0064 60.0959 53.3409 60.723 53.7605C61.3501 54.1807 61.8473 54.654 62.2138 55.1803C62.5803 55.7066 62.8357 56.2755 62.9775 56.8847C63.1193 57.4946 63.1903 58.1187 63.1903 58.757C63.1903 59.6095 63.0425 60.4195 62.7461 61.1891C62.4497 61.9581 61.9675 62.6359 61.2993 63.2219C60.6304 63.808 59.7555 64.2723 58.673 64.6149C57.5898 64.9583 56.2618 65.13 54.6873 65.13H42.99C42.8713 65.13 42.7825 65.1032 42.7242 65.0502C42.6653 64.9972 42.6324 64.9382 42.6257 64.8725C42.6205 64.8076 42.6436 64.7456 42.6966 64.6859C42.7504 64.6269 42.8303 64.5858 42.937 64.5619C43.0789 64.5381 43.3036 64.488 43.6111 64.4111C43.9195 64.3342 44.23 64.1954 44.5435 63.9939C44.8571 63.793 45.1318 63.5206 45.3692 63.1772C45.6058 62.8338 45.7238 62.3843 45.7238 61.8282V44.4677C45.7238 43.9235 45.6051 43.4763 45.3692 43.1276C45.1318 42.779 44.8578 42.5065 44.5435 42.3109C44.23 42.1153 43.9195 41.9765 43.6111 41.8937C43.3036 41.8108 43.0789 41.7578 42.937 41.7339C42.8303 41.722 42.7504 41.6839 42.6966 41.6182C42.6436 41.5532 42.6205 41.4883 42.6257 41.4226C42.6317 41.3576 42.6645 41.2987 42.7242 41.2449C42.7825 41.1919 42.8721 41.165 42.99 41.165H55.3443C56.5873 41.165 57.6257 41.3128 58.4603 41.6085C59.2942 41.9048 59.969 42.3102 60.4841 42.8246C60.9992 43.3389 61.3657 43.9429 61.5837 44.6349C61.8032 45.3269 61.9122 46.0637 61.9122 46.8446C61.9122 47.3888 61.8532 47.9338 61.7353 48.478C61.6166 49.0223 61.4188 49.5433 61.1411 50.0405C60.8626 50.5377 60.4901 50.9991 60.0227 51.4253C59.5554 51.8516 58.9784 52.2241 58.2916 52.5436C58.2207 52.5787 58.1908 52.6175 58.2035 52.6593C58.2147 52.7011 58.2557 52.734 58.3267 52.7579ZM51.581 51.1954C51.581 51.5268 51.6729 51.7904 51.8565 51.9852C52.0402 52.1808 52.3029 52.2778 52.6456 52.2778C52.9539 52.2778 53.2936 52.2069 53.6668 52.0651C54.0401 51.9233 54.385 51.6478 54.7052 51.2394C55.0248 50.8311 55.2913 50.2578 55.504 49.518C55.7168 48.7781 55.8235 47.8114 55.8235 46.6155C55.8235 46.0951 55.8056 45.5681 55.7698 45.0358C55.7347 44.5035 55.6392 44.0213 55.4861 43.589C55.3323 43.1575 55.1076 42.8052 54.812 42.5334C54.5156 42.2609 54.1073 42.1251 53.5862 42.1251C53.16 42.1251 52.8143 42.2049 52.5478 42.3647C52.282 42.5245 52.0775 42.7671 51.9357 43.0925C51.7938 43.418 51.699 43.8204 51.652 44.2997C51.6042 44.779 51.581 45.3381 51.581 45.9771V51.1954ZM53.943 64.1185C54.4044 64.1185 54.7919 64.0207 55.1054 63.8259C55.4189 63.6303 55.6795 63.3735 55.8863 63.0532C56.0931 62.7337 56.2528 62.3761 56.3663 61.9797C56.479 61.5833 56.5581 61.1839 56.6059 60.7815C56.6529 60.3791 56.6828 59.9947 56.6948 59.6281C56.706 59.2616 56.7119 58.948 56.7119 58.6875C56.7119 57.7887 56.641 57.028 56.4992 56.4069C56.3573 55.7858 56.1677 55.2736 55.9311 54.8713C55.6937 54.4689 55.4309 54.1584 55.1405 53.9389C54.8508 53.7201 54.5612 53.5604 54.2715 53.4596C53.9811 53.3588 53.7027 53.2999 53.4369 53.2819C53.1712 53.264 52.9487 53.2551 52.7718 53.2551C52.4045 53.2551 52.1148 53.3528 51.902 53.5477C51.6893 53.7433 51.5825 54.0068 51.5825 54.3375V59.9111C51.5825 60.5501 51.6154 61.1301 51.6796 61.6505C51.7453 62.1715 51.8662 62.612 52.0439 62.9733C52.2208 63.3339 52.4612 63.6153 52.7621 63.8161C53.0637 64.0177 53.4571 64.1185 53.943 64.1185Z",
    fill: "#121212"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4753 60.0178C86.5463 59.8282 86.659 59.7431 86.812 59.7603C86.9658 59.7782 87.0427 59.882 87.0427 60.0708V64.7926C87.0427 65.0173 86.9188 65.13 86.6694 65.13H67.8181C67.6994 65.13 67.6106 65.1032 67.5524 65.0502C67.4934 64.9972 67.4606 64.9382 67.4538 64.8725C67.4486 64.8076 67.4717 64.7456 67.5247 64.6859C67.5785 64.6269 67.6584 64.5858 67.7651 64.5619C67.907 64.5381 68.1317 64.488 68.4393 64.4111C68.7476 64.3342 69.0581 64.1954 69.3717 63.9939C69.6852 63.793 69.9599 63.5206 70.1973 63.1772C70.434 62.8338 70.5519 62.3843 70.5519 61.8282V44.4677C70.5519 43.9235 70.4332 43.4763 70.1973 43.1276C69.9599 42.779 69.6859 42.5065 69.3717 42.3109C69.0581 42.1153 68.7476 41.9765 68.4393 41.8937C68.1317 41.8108 67.907 41.7578 67.7651 41.7339C67.6584 41.722 67.5785 41.6839 67.5247 41.6182C67.4717 41.5532 67.4486 41.4883 67.4538 41.4226C67.4598 41.3576 67.4926 41.2987 67.5524 41.2449C67.6106 41.1919 67.7002 41.165 67.8181 41.165H85.1256C85.3735 41.165 85.4989 41.2777 85.4989 41.5024V45.1948C85.4989 45.3725 85.428 45.4695 85.2861 45.4874C85.1435 45.5046 85.0256 45.4314 84.93 45.2657C84.8591 45.1119 84.7173 44.8663 84.5045 44.5289C84.2917 44.1922 83.9961 43.8488 83.6176 43.4994C83.2384 43.1501 82.7651 42.8425 82.197 42.576C81.6289 42.3102 80.9488 42.1766 80.1552 42.1766C79.5991 42.1766 79.0907 42.2244 78.6293 42.3192C78.1672 42.414 77.7738 42.5648 77.4484 42.7715C77.1229 42.9783 76.869 43.2449 76.6854 43.5703C76.5025 43.8958 76.4099 44.2892 76.4099 44.7506V52.2412V51.9755C76.4099 52.0464 76.4368 52.1084 76.4905 52.1614C76.5435 52.2151 76.6055 52.2412 76.6772 52.2412H78.9489C79.4819 52.2412 79.9164 52.1345 80.2538 51.9217C80.5912 51.709 80.857 51.4604 81.0526 51.1767C81.2474 50.893 81.3863 50.6116 81.4691 50.3331C81.552 50.0554 81.605 49.8449 81.6289 49.7031C81.6408 49.6083 81.6789 49.5411 81.7446 49.4993C81.8096 49.4582 81.8745 49.4403 81.9395 49.4463C82.0044 49.4522 82.0641 49.4813 82.1171 49.5351C82.1701 49.5888 82.197 49.662 82.197 49.7568V55.7918C82.197 55.8866 82.1701 55.9605 82.1171 56.0135C82.0641 56.0672 82.0044 56.0963 81.9395 56.1023C81.8745 56.1083 81.8096 56.0904 81.7446 56.0486C81.6789 56.0075 81.6408 55.9396 81.6289 55.8447C81.605 55.7029 81.552 55.4924 81.4691 55.2147C81.3863 54.937 81.2474 54.6555 81.0526 54.3718C80.857 54.0882 80.5912 53.8396 80.2538 53.6261C79.9164 53.4133 79.4819 53.3065 78.9489 53.3065H76.6772C76.6055 53.3065 76.5435 53.3334 76.4905 53.3864C76.4368 53.4394 76.4099 53.5014 76.4099 53.5723V53.3065V61.49C76.4099 62.3298 76.7765 62.9696 77.5103 63.4071C78.2434 63.8445 79.2848 64.0632 80.6345 64.0632C81.2736 64.0632 81.8558 63.9781 82.3829 63.8064C82.9092 63.6347 83.3832 63.419 83.8028 63.1585C84.2231 62.8979 84.5896 62.606 84.9031 62.2798C85.2167 61.9543 85.4825 61.6438 85.7019 61.3482C85.9214 61.0525 86.0924 60.783 86.217 60.5404C86.3417 60.2985 86.4276 60.1238 86.4753 60.0178Z",
    fill: "#121212"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5703 65.0391V58.7198C91.5703 58.5189 91.6413 58.4032 91.7831 58.3741C91.9249 58.3442 92.0317 58.4129 92.1026 58.5779C92.5281 59.5484 92.9925 60.4062 93.4956 61.1519C93.998 61.8977 94.5542 62.5218 95.1641 63.025C95.7733 63.5281 96.4452 63.9096 97.1782 64.1694C97.9121 64.4299 98.7288 64.5598 99.6283 64.5598C100.137 64.5598 100.622 64.4859 101.083 64.3381C101.545 64.1903 101.951 63.9559 102.299 63.6371C102.648 63.3176 102.927 62.9093 103.134 62.4121C103.341 61.9149 103.445 61.3177 103.445 60.6197C103.445 59.9567 103.323 59.3745 103.08 58.8713C102.838 58.3681 102.512 57.9217 102.105 57.5313C101.695 57.1409 101.232 56.8004 100.712 56.5108C100.19 56.2211 99.6575 55.9576 99.114 55.7209C98.5101 55.4611 97.9158 55.1887 97.3298 54.9042C96.7438 54.6206 96.1846 54.3003 95.6523 53.9457C95.1193 53.5911 94.6311 53.182 94.1869 52.7207C93.7435 52.2593 93.3679 51.7263 93.0596 51.1231C92.7871 50.602 92.5774 50.0697 92.4303 49.5255C92.2825 48.9813 92.2078 48.4192 92.2078 47.8391C92.2078 46.9985 92.3557 46.1527 92.6521 45.3009C92.9477 44.4491 93.4329 43.6802 94.1078 42.9934C94.7827 42.3073 95.6613 41.7482 96.7437 41.316C97.8262 40.8845 99.1603 40.668 100.747 40.668C101.752 40.668 102.622 40.7479 103.356 40.9076C104.089 41.0674 104.701 41.245 105.193 41.4399C105.683 41.6347 106.06 41.8184 106.32 41.9901C106.581 42.1618 106.728 42.2648 106.764 42.3006C106.906 42.4074 106.977 42.5313 106.977 42.6732V45.9034C106.977 45.9862 106.953 46.0542 106.906 46.1079C106.858 46.1609 106.805 46.1908 106.746 46.1968C106.688 46.2027 106.628 46.1908 106.57 46.1609C106.51 46.1318 106.463 46.0758 106.428 45.9922C106.202 45.4599 105.937 44.9299 105.629 44.4036C105.321 43.8773 104.933 43.4092 104.466 43.0016C103.999 42.5933 103.427 42.2618 102.753 42.0072C102.078 41.7527 101.267 41.6258 100.321 41.6258C99.0901 41.6258 98.1315 41.9162 97.4455 42.4955C96.7587 43.0755 96.416 43.8624 96.416 44.856C96.416 45.4241 96.5109 45.9213 96.6997 46.3468C96.8893 46.7731 97.2111 47.1725 97.6672 47.545C98.1226 47.9175 98.7295 48.29 99.4873 48.6633C100.244 49.0365 101.197 49.4531 102.345 49.9152C103.457 50.3646 104.44 50.8498 105.291 51.3702C106.144 51.8913 106.856 52.4743 107.43 53.1186C108.004 53.7636 108.436 54.4944 108.726 55.3104C109.017 56.1271 109.161 57.0625 109.161 58.1151C109.161 59.1565 108.975 60.1329 108.602 61.0437C108.23 61.9552 107.659 62.751 106.889 63.4311C106.12 64.1119 105.15 64.6464 103.978 65.0368C102.807 65.428 101.427 65.6229 99.8426 65.6229C98.8363 65.6229 97.8389 65.4959 96.8513 65.2414C95.8636 64.9868 94.9081 64.7062 93.9854 64.3979C93.8547 64.3508 93.7121 64.303 93.5591 64.256C93.4053 64.209 93.2582 64.1851 93.1156 64.1851C92.8319 64.1851 92.6244 64.2769 92.4938 64.4598C92.3639 64.6434 92.2392 64.8711 92.1205 65.1436C92.0496 65.3093 91.9406 65.3803 91.792 65.3564C91.645 65.3347 91.5703 65.2279 91.5703 65.0391Z",
    fill: "#121212"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M134.06 41.5025V46.4378C134.06 46.6267 133.982 46.7304 133.829 46.7483C133.675 46.7662 133.563 46.6804 133.492 46.4908C133.444 46.384 133.361 46.2041 133.244 45.9495C133.125 45.695 132.96 45.4083 132.746 45.0888C132.534 44.7693 132.273 44.4408 131.966 44.1034C131.657 43.7667 131.296 43.4554 130.882 43.1717C130.467 42.8881 130.003 42.6544 129.489 42.47C128.974 42.2871 128.397 42.1952 127.758 42.1952C127.462 42.1952 127.219 42.2393 127.03 42.3282C126.841 42.417 126.69 42.5357 126.578 42.6835C126.464 42.8313 126.385 43.006 126.338 43.2068C126.29 43.4084 126.261 43.6152 126.249 43.8279V61.8274C126.249 62.3843 126.367 62.833 126.604 63.1764C126.841 63.5198 127.116 63.7915 127.43 63.9931C127.743 64.1947 128.054 64.3335 128.361 64.4104C128.67 64.4873 128.894 64.5373 129.036 64.5612C129.143 64.5851 129.223 64.6262 129.276 64.6851C129.33 64.7441 129.353 64.8068 129.347 64.8718C129.341 64.9367 129.309 64.9964 129.249 65.0494C129.19 65.1032 129.1 65.1293 128.983 65.1293H117.658C117.54 65.1293 117.451 65.1024 117.392 65.0494C117.332 64.9964 117.3 64.9375 117.294 64.8718C117.288 64.8068 117.312 64.7449 117.365 64.6851C117.418 64.6262 117.499 64.5851 117.605 64.5612C117.746 64.5373 117.971 64.4873 118.279 64.4104C118.587 64.3335 118.898 64.1947 119.211 63.9931C119.525 63.7923 119.8 63.5198 120.037 63.1764C120.274 62.833 120.393 62.3836 120.393 61.8274C120.393 61.7334 120.393 61.434 120.393 60.9308C120.393 60.4284 120.393 59.7946 120.393 59.0317C120.393 58.268 120.393 57.4132 120.393 56.4666C120.393 55.52 120.395 54.5465 120.402 53.5469C120.407 52.5473 120.41 51.5589 120.41 50.5825C120.41 49.606 120.41 48.7132 120.41 47.9017C120.41 47.091 120.41 46.393 120.41 45.807C120.41 45.2209 120.41 44.8275 120.41 44.6267C120.41 44.3311 120.402 44.0377 120.383 43.748C120.365 43.4584 120.309 43.1978 120.215 42.9672C120.119 42.7365 119.969 42.5499 119.762 42.408C119.555 42.2662 119.262 42.1952 118.883 42.1952C118.244 42.1952 117.664 42.2871 117.143 42.47C116.623 42.6536 116.159 42.8873 115.75 43.1717C115.342 43.4554 114.984 43.7667 114.677 44.1034C114.368 44.4408 114.108 44.7693 113.895 45.0888C113.682 45.4083 113.514 45.6957 113.39 45.9495C113.266 46.2041 113.185 46.3848 113.15 46.4908C113.079 46.6804 112.966 46.7662 112.812 46.7483C112.658 46.7311 112.582 46.6274 112.582 46.4378V41.5025C112.582 41.2778 112.706 41.165 112.954 41.165H133.687C133.935 41.1658 134.06 41.2778 134.06 41.5025Z",
    fill: "#121212"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_56478",
    x1: 74.5521,
    y1: -2.05416,
    x2: 74.5521,
    y2: 161.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_198_56478",
    x1: 64.0851,
    y1: -2.05747,
    x2: 64.0851,
    y2: 161.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_198_56478",
    x1: 53.952,
    y1: -2.05546,
    x2: 53.952,
    y2: 161.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_198_56478",
    x1: 44.394,
    y1: -2.0545,
    x2: 44.394,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_198_56478",
    x1: 35.5417,
    y1: -2.05038,
    x2: 35.5417,
    y2: 161.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_198_56478",
    x1: 27.7348,
    y1: -2.05699,
    x2: 27.7348,
    y2: 161.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_198_56478",
    x1: 21.37,
    y1: -2.04923,
    x2: 21.37,
    y2: 161.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_198_56478",
    x1: 16.9035,
    y1: -2.05276,
    x2: 16.9035,
    y2: 161.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_198_56478",
    x1: 13.956,
    y1: -2.04667,
    x2: 13.956,
    y2: 161.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_198_56478",
    x1: 12.4209,
    y1: -2.05225,
    x2: 12.4209,
    y2: 161.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_198_56478",
    x1: 12.2939,
    y1: -2.05681,
    x2: 12.2939,
    y2: 161.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_198_56478",
    x1: 13.5959,
    y1: -2.05268,
    x2: 13.5959,
    y2: 161.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_198_56478",
    x1: 70.4311,
    y1: -2.05736,
    x2: 70.4311,
    y2: 161.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_198_56478",
    x1: 59.5099,
    y1: -2.05514,
    x2: 59.5099,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_198_56478",
    x1: 48.8556,
    y1: -2.05856,
    x2: 48.8556,
    y2: 161.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_198_56478",
    x1: 38.7448,
    y1: -2.04862,
    x2: 38.7448,
    y2: 161.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_198_56478",
    x1: 29.5821,
    y1: -2.04827,
    x2: 29.5821,
    y2: 161.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_198_56478",
    x1: 21.6533,
    y1: -2.05385,
    x2: 21.6533,
    y2: 161.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_198_56478",
    x1: 15.2321,
    y1: -2.05349,
    x2: 15.2321,
    y2: 161.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_198_56478",
    x1: 10.3935,
    y1: -2.04939,
    x2: 10.3935,
    y2: 161.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_198_56478",
    x1: 7.08668,
    y1: -2.05863,
    x2: 7.08668,
    y2: 161.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_198_56478",
    x1: 5.2193,
    y1: -2.05178,
    x2: 5.2193,
    y2: 161.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_198_56478",
    x1: 4.7134,
    y1: -2.05332,
    x2: 4.7134,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_198_56478",
    x1: 5.73055,
    y1: -2.05325,
    x2: 5.73055,
    y2: 161.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_198_56478",
    x1: 24.2508,
    y1: -2.0551,
    x2: 24.2508,
    y2: 161.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_198_56478",
    x1: 19.3855,
    y1: -2.05044,
    x2: 19.3855,
    y2: 161.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_198_56478",
    x1: 18.8066,
    y1: -2.05029,
    x2: 18.8066,
    y2: 161.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_198_56478",
    x1: 103.443,
    y1: -2.05612,
    x2: 103.443,
    y2: 161.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_198_56478",
    x1: 113.929,
    y1: -2.05942,
    x2: 113.929,
    y2: 161.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_198_56478",
    x1: 124.054,
    y1: -2.05742,
    x2: 124.054,
    y2: 161.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_198_56478",
    x1: 133.609,
    y1: -2.05645,
    x2: 133.609,
    y2: 161.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_198_56478",
    x1: 142.471,
    y1: -2.05234,
    x2: 142.471,
    y2: 161.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_198_56478",
    x1: 150.278,
    y1: -2.05895,
    x2: 150.278,
    y2: 161.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_198_56478",
    x1: 156.624,
    y1: -2.05118,
    x2: 156.624,
    y2: 161.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_198_56478",
    x1: 161.087,
    y1: -2.05471,
    x2: 161.087,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_198_56478",
    x1: 164.05,
    y1: -2.04862,
    x2: 164.05,
    y2: 161.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_198_56478",
    x1: 165.592,
    y1: -2.0542,
    x2: 165.592,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_198_56478",
    x1: 165.715,
    y1: -2.05778,
    x2: 165.715,
    y2: 161.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_198_56478",
    x1: 164.416,
    y1: -2.05463,
    x2: 164.416,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_198_56478",
    x1: 107.572,
    y1: -2.05638,
    x2: 107.572,
    y2: 161.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_198_56478",
    x1: 118.486,
    y1: -2.05514,
    x2: 118.486,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_198_56478",
    x1: 129.144,
    y1: -2.05856,
    x2: 129.144,
    y2: 161.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_198_56478",
    x1: 139.249,
    y1: -2.04862,
    x2: 139.249,
    y2: 161.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_198_56478",
    x1: 148.434,
    y1: -2.04534,
    x2: 148.434,
    y2: 161.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_198_56478",
    x1: 156.357,
    y1: -2.05385,
    x2: 156.357,
    y2: 161.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_198_56478",
    x1: 162.779,
    y1: -2.05349,
    x2: 162.779,
    y2: 161.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_198_56478",
    x1: 167.601,
    y1: -2.04939,
    x2: 167.601,
    y2: 161.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_198_56478",
    x1: 170.926,
    y1: -2.05863,
    x2: 170.926,
    y2: 161.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_198_56478",
    x1: 172.779,
    y1: -2.05178,
    x2: 172.779,
    y2: 161.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_198_56478",
    x1: 173.283,
    y1: -2.05332,
    x2: 173.283,
    y2: 161.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_198_56478",
    x1: 172.254,
    y1: -2.05325,
    x2: 172.254,
    y2: 161.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_198_56478",
    x1: 153.759,
    y1: -2.05608,
    x2: 153.759,
    y2: 161.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_198_56478",
    x1: 158.626,
    y1: -2.05142,
    x2: 158.626,
    y2: 161.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_198_56478",
    x1: 159.205,
    y1: -2.05127,
    x2: 159.205,
    y2: 161.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_198_56478",
    x1: 88.7299,
    y1: -2.05044,
    x2: 88.7299,
    y2: 161.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0051,
    stopColor: "#6E3E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0088,
    stopColor: "#80562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0155,
    stopColor: "#9D7A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#B69A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    stopColor: "#CBB67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0407,
    stopColor: "#DCCC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517,
    stopColor: "#E9DD9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0652,
    stopColor: "#F2E8A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0843,
    stopColor: "#F8EFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#F9F1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#F8EBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1603,
    stopColor: "#F6E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    stopColor: "#F5DB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#F5D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2303,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3152,
    stopColor: "#F4D365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3165,
    stopColor: "#F4D467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3318,
    stopColor: "#F6E279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3498,
    stopColor: "#F8EB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#F9F08E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4224,
    stopColor: "#F9F290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4936,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5013,
    stopColor: "#F7EFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F0DD82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#EAD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#E7C95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6606,
    stopColor: "#E6C65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6842,
    stopColor: "#EAD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    stopColor: "#F5E9A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#F8F1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7621,
    stopColor: "#EDDD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#E0C470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#D5B052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#CDA13D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8606,
    stopColor: "#C99930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#C7962C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C99B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9009,
    stopColor: "#D1A843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DCBD60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#ECDB87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#F9F3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#F6EFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9542,
    stopColor: "#EDE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#DED28C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#C8B778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#AD955E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#8B6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#643C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.a28e04070448080df85cad2ea7b85f3e.svg";
export { ForwardRef as ReactComponent };